import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PromoHighlightComponent } from './promo-highlight/promo-highlight.component';
import { PromoPopupComponent } from './promo-popup/promo-popup.component'
import { PromoListComponent } from '../promo/promo-list/promo-list.component';
import { PromosService} from '../services/promos/promos.service';


@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
      PromoHighlightComponent
  ],
  declarations: [
      PromoHighlightComponent,
      PromoPopupComponent,
      PromoListComponent
  ],
  providers: [
      PromosService
  ]
})


export class PromoModule { }



// WEBPACK FOOTER //
// ./src/app/promo/promo.module.ts